import { PaymentStatus } from '@repo/common';
import { Card, CardContent, CardHeader, CardTitle } from '@repo/shadcn';

import { DataTable } from '@/components/ui/data.table/data-table';
import PaginationComponent from '@/components/ui/pagination';
import { SelectFilter, TextSearchFilter } from '@/components/ui/search-filter';
import { DEFAULT_PAGE_LIMIT } from '@/constants';
import { useUrlFilter } from '@/hooks';
import { PAYMENT_STATUS_FILTER_KEY } from '@/modules/sales/order-list/constant';
import { orderListColumns } from '@/modules/sales/order-list/order-list.column';
import { useOrderList } from '@/modules/sales/order-list/order-list.hook';

import { useCustomerDetailsContext } from './context';

export const OrderHistory = () => {
    const { setSearchText, setSearchFilter, getSearchFilter, searchText } =
        useUrlFilter();
    const paymentStatusFilter =
        getSearchFilter(PAYMENT_STATUS_FILTER_KEY) || '';

    const { data: customerData } = useCustomerDetailsContext();

    const { data, isLoading, page, setCurrentPage } = useOrderList({
        customerId: customerData?.id,
    });

    return (
        <Card>
            <CardHeader className="gap-3 p-4 pb-0 sm:p-6 sm:pb-0">
                <CardTitle>Order History</CardTitle>
                <div className="grid w-full grid-cols-1 gap-2 font-normal sm:grid-cols-2 lg:flex lg:justify-end">
                    <div className="min-w-0 [&_input]:!w-full">
                        <TextSearchFilter
                            onChangeSearch={(e) =>
                                setSearchText(e.target.value)
                            }
                            placeholder="Search orders"
                            value={searchText}
                        />
                    </div>
                    <SelectFilter
                        className="w-full lg:w-auto [&_[role=combobox]]:!w-full"
                        title="Status"
                        placeholder="Payment Status"
                        onChange={(value) =>
                            setSearchFilter(PAYMENT_STATUS_FILTER_KEY, value)
                        }
                        value={paymentStatusFilter}
                        options={[
                            { label: 'Paid', value: PaymentStatus.PAID },
                            { label: 'Due', value: PaymentStatus.DUE },
                        ]}
                    />
                </div>
            </CardHeader>
            <CardContent className="min-w-0 p-3 pt-4 sm:p-6 sm:pt-4">
                <DataTable
                    columns={orderListColumns}
                    data={data?.data || []}
                    isLoading={isLoading}
                />
                <p className="mt-3 flex w-full items-center px-4 text-right font-semibold">
                    Total Found : {data?.pagination?.total_items}
                </p>
                <div className="w-full overflow-x-auto [&_[role=navigation]>ul]:min-w-max [&_[role=navigation]]:justify-start sm:[&_[role=navigation]]:justify-center">
                    <PaginationComponent
                        showTotalItems
                        totalItems={data?.pagination?.total_items || 0}
                        itemsPerPage={
                            data?.pagination?.limit || DEFAULT_PAGE_LIMIT
                        }
                        initialPage={page}
                        onPageChange={(p) => {
                            setCurrentPage(p);
                        }}
                    />
                </div>
            </CardContent>
        </Card>
    );
};

OrderHistory.displayName = 'OrderHistory';
